import React from 'react';
import { Form, Select } from 'antd';

function SelectInput({
  name,
  label,
  errorMessage,
  disabled = false,
  options = [],
  labelName = 'label',
  valueName = 'value',
}) {
  return (
    <Form.Item
      label={label}
      name={name}
      validateStatus={errorMessage && 'error'}
      help={errorMessage}
    >
      <Select
        disabled={disabled}
        options={options?.map((option) => ({
          label: option?.[labelName],
          value: option?.[valueName],
        }))}
        allowClear
      />
    </Form.Item>
  );
}

export default SelectInput;
